<template lang="html">
  <div class="features detail-intro bg-color-green pb-3" v-if="news">
    <div class="container-fluid ">
      <div class="row ">
        <div class="col-md-12">
          <img class="pb-1 review-logo" width="150" src="@/assets/auto_reviewklein.jpg">
        </div>
      </div>
      <div class="row justify-content-center mb-3 review-content" style="gap: 30px" itemscope="itemscope" itemtype="https://schema.org/NewsArticle">

        <div class="col-md-3 intro">
          <h2 class="headline" itemprop="headline"> {{ news[0].title ? news[0].title : news[0].photos[0].alt}}</h2>
          <div itemprop="text" v-html="news[0].intro"></div>
          <p class="news-body" itemprop="articleBody" v-if="news[0].body" v-html="removeBrackets(news[0].body)"></p>
          <a class="specs" target="_blank " itemprop="url" style="color: white" :href="fixReviewURL()">Lees meer op Auto Review</a>
        </div>

        <div class="d-flex align-items-center col-md-4">
          <div class="align-items-center ">
            <div class="ad-logo">
              <div class="outer-spin" style="z-index: -1">
                <div class="outer-arc outer-arc_start-a"></div>
                <div class="outer-arc outer-arc_end-a"></div>
                <div class="outer-arc outer-arc_start-b"></div>
                <div class="outer-arc outer-arc_end-b"></div>
                <div class="outer-moon-a"></div>
                <div class="outer-moon-b"></div>
              </div>
              <!--              <template v-if="news[1]?.photos && news[1].photos[0]?.url">-->
              <!--                <img class="rounded" itemprop="image" :src="news[1].photos[0].url.replace('original', 600)" width="400" style="z-index: 999; margin-bottom: 10px;">-->
              <!--              </template>-->
            </div>
            <img class="rounded img-fluid" itemprop="image" v-if="news[0].photos[0].url"
                 :src="news[0].photos[0].url?.replace('original', 1280)" width="700" height="500" style="z-index: 999; ">
          </div>

        </div>
      </div>

    </div>


  </div>

</template>

<script>
export default {
  name: "autoreview",


  computed: {
    news() {
      return this.$store.state.news
    },
  },

  methods: {
    removeBrackets(content) {
      // Replace h1 headers with h4 headers
      const updatedContent = content.replace(/<h2>/g, '<h4>').replace(/<\/h2>/g, '</h4>');

      // Remove brackets
      const finalContent = updatedContent.replace(/\[[^\]]*]/g, '');

      return finalContent;
    },
    fixReviewURL() {
      return this.news[0].url.replace(".nl/", ".nl/autotests/");
    }
  },
}
</script>

<style scoped>

.specs {
  padding: 10px 20px;
  background: #2ecc71;
  margin-right: 5px;
  margin-left: 5px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  border: 2px solid #2ecc71;
  display: inline-block;
  margin-bottom: 10px;
  cursor: pointer;
}

a.specs {
  background: #fff !important;
  color: #2ecc71 !important;
}

a.specs:hover {
      color: #fff !important;
      background: #2ecc71 !important;
}

.ad-logo .outer-spin {
  opacity: 0.4;
  position: absolute;
  top: 12%;
  right: 38%;
  transform: scale(2);
}

.review-logo {
  position: relative;
  left: 20%;
}

@media (max-width: 1000px) {
  .review-logo {
    left: 0;
  }
}

@media (min-width: 400px) and (max-width: 1440px) {
  .review-content {
    flex-direction: column-reverse;
    align-items: center;
    width: 80%;
    margin: 0 auto;
  }
}

@media (min-width: 426px) and (max-width: 1440px) {
  .intro {
    max-width: 100%;
  }
  .headline {
    max-width: 150%;
  }
}

@media (min-width: 1000px) {
  .headline {
    width: fit-content;
  }
}
</style>
